"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDateValidationError = void 0;
const controls_1 = require("../../../controls");
const getDateValidationError = (code, texts = {}) => {
    const result = (() => {
        switch (code) {
            case controls_1.DATETIME_INPUT_ERROR.gtEnd:
                return texts.gtEndDateError;
            case controls_1.DATETIME_INPUT_ERROR.ltStart:
                return texts.ltStartDateError;
            case controls_1.DATETIME_INPUT_ERROR.parse:
                return texts.parseError;
            default:
                return '';
        }
    })();
    return result || texts.defaultError;
};
exports.getDateValidationError = getDateValidationError;
//# sourceMappingURL=getDateValidationError.js.map